import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IAdminService {
        getAllProductTypes: () => ng.IPromise<Array<Models.ProductModel.IProductModel>>;
    }

    export class AdminService implements IAdminService {
        public prefix: string;

        public static $inject = ['igs.apiClientService'];

        constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
            this.prefix = 'Admin';
        }

        public getAllProductTypes = (): ng.IPromise<Array<Models.ProductModel.ProductModel>> => {
            var url = `${this.prefix}/GetAllProductTypes`;
            return this.igsApiClientService.get(url);
        }
    }
